<div [ngClass]="isHovered ? 'card hover' : 'card'" (mouseenter)="isHovered = true" (mouseleave)="isHovered = false"  (click)="onCardClick()">
  <div class="icon-wrapper">
    <!-- Affiche l'icône personnalisée si l'URL est fournie, sinon l'icône Font Awesome -->
    <ng-container>
      <img
        [src]="isHovered ? hoverIconUrl : iconUrl"
        alt="Icon"
        class="custom-icon"
      />
    </ng-container>
  </div>
  <h4 class="card-title">{{ title }}</h4>
  <p class="card-description">{{ description }}</p>
</div>
